import axios from 'axios';
import { uuid } from 'vue-uuid';

export default {
  async simulate(payload) {
    
    const endpoint = process.env.VUE_APP_ENDPOINT_WS + 'socinal_simulate';
    
    try {
      return axios.post(endpoint, payload).then(r => r.data);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  async simulate_irregular(payload) {
    
    const endpoint = process.env.VUE_APP_ENDPOINT_WS + 'socinal_simulate_irregular';
        
    try {
      return axios.post(endpoint, payload).then(r => r.data);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  async inserir_proposta(payload) {
    
    const endpoint = process.env.VUE_APP_ENDPOINT_WS + 'socinal_inserir_proposta';
    
    try {
      return axios.post(endpoint, payload).then(r => r.data);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  generateCCB() {
    return uuid.v4();
  },

  generateHashAssinatura() {
    return uuid.v4();
  },

  generateHash() {
    return uuid.v4();
  }
};
